export enum ExportMode {
  CONVERSATIONS = 'conversations',
  DATA_GATHERING = 'data_gathering',
  LINK_TRACKING = 'link_tracking',
  AI_INSIGHTS = 'ai_insights',
  TRIAGE_DATA = 'triage_data',
}

export enum Extension {
  CSV = 'csv',
  XLSX = 'xlsx',
}

export interface UrlToFile {
  url: string;
}

export type ConversationExportJobStatus = 'pending' | 'running' | 'ready' | 'failed';

export interface ConversationExportJobResponse {
  job_id: string;
  status: ConversationExportJobStatus;
  estimated_rows: number;
  row_count: number | null;
  url: string | null;
  error_code: string | null;
  // Filter receipt; absent from a server revision that cannot apply the filter.
  metadata_key?: string | null;
}

export interface DataGatheringExportResponse extends UrlToFile {
  metadata_key?: string | null;
}

export interface ExportDownloadPayload {
  start_date: string;
  end_date: string;
  extension: Extension;
  query?: string;
  metadata_key?: string;
  metadata_value?: string;
  send_email_notification: boolean;
}

// Mirrors normalize_conversation_export_metadata_filter on the backend.
export const METADATA_FILTER_KEY_MAX_CHARS = 100;
export const METADATA_FILTER_VALUE_MAX_CHARS = 500;

// The two exports that select conversations; link tracking and AI insights select something else.
const METADATA_FILTER_EXPORT_MODES: ReadonlySet<ExportMode> = new Set([
  ExportMode.CONVERSATIONS,
  ExportMode.DATA_GATHERING,
]);

export const supportsMetadataFilter = (exportMode: ExportMode): boolean =>
  METADATA_FILTER_EXPORT_MODES.has(exportMode);

export interface ExportApiErrorPayload {
  detail?: string;
  message?: string;
  errors?: {
    root?: Array<{
      message: string;
      code: string;
      options?: {
        reason?: string;
      } | null;
    }>;
  };
}
